const { axios } =
  await import(`./index.js?v=${Date.now()}`);
const { returnStringOrNull } =
  await import(`./type-check.js?v=${Date.now()}`);
const { debounce } =
  await import(`./debounce.js?v=${Date.now()}`);
import "./_commonjsHelpers.js";
import "./recommended-products.js";
class storage {
  /**
   * Set store item.
   *
   * @param itemKey
   * @param value
   */
  setItem(itemKey, value) {
    sessionStorage.setItem(`${itemKey}`, `${value}`);
  }
  /**
   * Get store item.
   *
   * @param itemKey
   * @returns {string}
   */
  getItem(itemKey) {
    return returnStringOrNull(sessionStorage.getItem(`${itemKey}`));
  }
  /**
   * Remove store item.
   *
   * @param itemKey
   */
  removeItem(itemKey) {
    sessionStorage.removeItem(`${itemKey}`);
  }
}
var storage$1 = new storage();
class NoteHolder extends HTMLElement {
  constructor() {
    super();
    const storedNote = storage$1.getItem("note");
    const noteElement = this.querySelector("textarea");
    if (storedNote) {
      noteElement.value = storedNote;
    }
    if (noteElement.value.length > 0) {
      this.classList.add("js-has-value");
    }
    const updateCartNote = (value) => {
      const method = "POST";
      const url = window.routes.cart_update_url;
      const body = JSON.stringify({ note: value });
      try {
        axios({
          method,
          url,
          headers: {
            "Content-Type": "application/json",
            Accept: `application/json`
          },
          data: body
        });
      } catch (error) {
      }
    };
    noteElement.addEventListener(
      "input",
      debounce((event) => {
        if (event.target.value.length === 0) {
          storage$1.removeItem("note");
          this.classList.remove("js-has-value");
        }
        updateCartNote(event.target.value);
        storage$1.setItem("note", noteElement.value);
      }, 300)
    );
  }
}
if (customElements.get("note-holder") === void 0) {
  customElements.define("note-holder", NoteHolder);
}
